<template>
  <div>
    <div class="banner-pp">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082807390745.jpg"></el-image>
      <div class="cover">
        <h1>品牌系列</h1>
        <div class="subtitle">健康手套</div>
      </div>
    </div>
    <div class="p-box">
      <el-row>
        <el-col :span="10">
          <h1 v-if="productInfo!=null">{{ productInfo.name }}</h1>
          <div class="img" v-if="productInfo!=null">
            <el-image fit="fill"
                      :src="productInfo.coverUrl"></el-image>
          </div>
        </el-col>
        <el-col :span="14" v-if="productInfo!=null">
          <div class="desc">
            {{ productInfo.sellIntroduction }}
          </div>
          <div class="gg">
            <el-row>
              <el-col :span="4" class="title">产品描述</el-col>
              <el-col :span="6"> {{ productInfo.description }}</el-col>
              <el-col :span="4" class="title">型号</el-col>
              <el-col :span="6">{{ productInfo.models }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="title">材质</el-col>
              <el-col :span="6">{{ productInfo.material }}</el-col>
              <el-col :span="4" class="title">是否灭菌</el-col>
              <el-col :span="6">{{ productInfo.sterilize }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="title">工艺</el-col>
              <el-col :span="6">{{ productInfo.craft }}</el-col>
              <el-col :span="4" class="title">尺码</el-col>
              <el-col :span="6">{{ productInfo.sizes }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="title">颜色</el-col>
              <el-col :span="6">{{ productInfo.colors }}</el-col>
              <el-col :span="4" class="title">包装规格</el-col>
              <el-col :span="6">{{ productInfo.specification }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="title">麻面</el-col>
              <el-col :span="6">{{ productInfo.hempNoodles }}</el-col>
              <el-col :span="4" class="title">有效期</el-col>
              <el-col :span="6">{{ productInfo.validPeriod }}</el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--    <div class="p-border"></div>-->
    <div class="p-list">
      <el-row :gutter="20" v-if="productInfos!=null">
        <el-col :span="6" v-for="(item,index) in productInfos" :key="index">
          <div class="item" @click="newsDetail(item);">
            <div class="p-img">
              <el-image :src="item.coverUrl"></el-image>
            </div>
            <div class="name">
              {{ item.name }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {getProductInfoDetail} from "@/api/api";

export default {
  name: "Index",
  data() {
    return {
      productInfo: null,
      productInfos: null
    }
  },
  created() {
    this.getDetail(this.$route.query.id);
  },
  methods: {
    newsDetail(item) {
      this.getDetail(item.id);
    },
    getDetail(id) {
      getProductInfoDetail(id).then((res) => {
        this.productInfo = res.data.productInfo;
        this.productInfos = res.data.productInfos;
      });
    }
  }
}
</script>

<style scoped>
@import url("Index.css");
</style>